import { registerBlockType } from '@wordpress/blocks';

import metadata from '../inc/block.json';
import Edit from './Components/Backend/Edit';
import './editor.scss';
import { chartIcon } from './utils/icons';

registerBlockType(metadata, {
	icon: chartIcon,

	// Build in Functions
	edit: Edit,

	save: () => null
});